import axios from 'axios';
import {
  getAmplitudeDeviceId,
  getAmplitudeSessionId,
  identifyAmplitudeUser,
} from '@/helper/amplitudeBrowser';
import { useSessionStorage } from '../useSessionStorage';
import AmplitudeInstance from './amplitude';

// Geo lookup is best effort: ipapi.co is rate limited and gets blocked by ad
// blockers, and a rejected request here used to take the whole event with it.
const getInfo = async () => {
  const { get, set } = useSessionStorage();
  const cached = get('userInfoLK');
  if (cached) return cached;

  try {
    const { data } = await axios.get('https://ipapi.co/json/');
    set('userInfoLK', data);
    return data;
  } catch {
    return {};
  }
};

async function sendEvent({ event_type, email }) {
  const info = await getInfo();

  // Same device/session the landing uses for `Page View`, so the visit and the
  // account events end up on one profile timeline instead of two.
  const deviceId = getAmplitudeDeviceId();
  const sessionId = getAmplitudeSessionId();

  if (email) identifyAmplitudeUser(email);

  AmplitudeInstance.logEvent({
    event_type: event_type || 'Unknown Event',
    // Without a device id there is nothing to key an anonymous event on, so
    // fall back to the old placeholder. With one, skip it — a shared
    // `unauthorized` user_id collapses every guest into a single profile.
    user_id: email || (deviceId ? undefined : 'unauthorized'),
    device_id: deviceId,
    session_id: sessionId,
    location_lat: info.latitude,
    location_lng: info.longitude,
    ip: info.ip,
  });
}

function AmplitudeSendEvent({ event_type, email }) {
  // Analytics must never break the flow it is measuring.
  sendEvent({ event_type, email }).catch(() => {});
}

export default AmplitudeSendEvent;
